var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canRead || _vm.isTenant
    ? _c(
        "div",
        { staticClass: "insurance" },
        [
          _c("Collapse", { staticClass: "insurance__collaspe" }, [
            _c(
              "div",
              {
                staticClass: "insurance__collaspe-title-box",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "span",
                  { staticClass: "insurance__collaspe-title default-title" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("tenantProjects.insurance.title")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.initInsurance.startDate && _vm.initInsurance.endDate
                  ? _c(
                      "span",
                      { staticClass: "insurance__collaspe-status float-right" },
                      [
                        _c("i", {
                          staticClass:
                            "insurance__collaspe-status_check fa fa-check",
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("tenantProjects.insurance.validFrom", [
                                _vm.$options.filters["formatDate"](
                                  _vm.initInsurance.startDate,
                                  "DD MMM YYYY"
                                ),
                                _vm.$options.filters["formatDate"](
                                  _vm.initInsurance.endDate,
                                  "DD MMM YYYY"
                                ),
                              ])
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "insurance__collaspe-content",
                attrs: { slot: "content" },
                slot: "content",
              },
              [
                _c(
                  "div",
                  { staticClass: "insurance__collaspe-content-header" },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          class: [
                            {
                              "required-flag": _vm.isEngineer && _vm.canUpdate,
                            },
                            "blod-p",
                          ],
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "tenantProjects.insurance.coveragePeriod"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.insurance.updater
                        ? _c("div", { staticClass: "last-update" }, [
                            _c("div", { staticClass: "last-update__text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("lastUpdatedBy", [
                                      _vm.insurance.updater.displayName,
                                      _vm.$options.filters["formatDate"](
                                        _vm.insurance.updatedAt,
                                        "DD MMM YY HH:mm"
                                      ),
                                    ])
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isEngineer && _vm.canUpdate && !_vm.isWithdrawn
                      ? _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn--darkblue",
                              on: {
                                click: function ($event) {
                                  return _vm.confirm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.confirm")))]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTenant && _vm.isAppendFile
                      ? _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn--darkblue",
                              on: {
                                click: function ($event) {
                                  return _vm.tenantConfirm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("action.confirm")))]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "inline-block",
                    attrs: { id: "insuranceFrom" },
                  },
                  [
                    _c("label", { staticClass: "inline-block__item" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm.$t("tender.attachment.effectiveFrom")
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.isEngineer && _vm.canUpdate
                      ? _c("DatePicker", {
                          staticClass: "inline-block__item",
                          attrs: {
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            required: true,
                            value: _vm._f("formatDate")(
                              _vm.insurance.startDate
                            ),
                            disabledPicker: _vm.isWithdrawn,
                            disabled: {
                              from: _vm.insurance.endDate
                                ? new Date(_vm.insurance.endDate)
                                : null,
                            },
                          },
                          on: {
                            selected: function (val) {
                              return (_vm.insurance.startDate = val)
                            },
                          },
                        })
                      : _c("span", { staticClass: "inline-block__item" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("isEmptyValue")(
                                  _vm._f("formatDate")(_vm.insurance.startDate)
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "inline-block__item" }, [
                      _vm._v(_vm._s(_vm._f("capitalize")(_vm.$t("dateTo")))),
                    ]),
                    _vm._v(" "),
                    _vm.isEngineer && _vm.canUpdate
                      ? _c("DatePicker", {
                          staticClass: "inline-block__item",
                          attrs: {
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            required: true,
                            value: _vm._f("formatDate")(_vm.insurance.endDate),
                            disabledPicker: _vm.isWithdrawn,
                            disabled: {
                              to: _vm.insurance.startDate
                                ? new Date(_vm.insurance.startDate)
                                : null,
                            },
                          },
                          on: {
                            selected: function (val) {
                              return (_vm.insurance.endDate = val)
                            },
                          },
                        })
                      : _c("span", { staticClass: "inline-block__item" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("isEmptyValue")(
                                  _vm._f("formatDate")(_vm.insurance.endDate)
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "insurance__doc-title blod-p" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("tenantProjects.insurance.document")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _vm.canEdit
                  ? _c("p", { staticClass: "insurance__doc-hint" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("tenantProjects.insurance.documentHint")
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.canEdit
                  ? _c("HkldDropzone", {
                      staticClass: "uploadfileszone",
                      attrs: { sourceId: _vm.sourceId },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("EditAttachments", {
                  ref: "editAttachments",
                  attrs: {
                    sourceId: _vm.sourceId,
                    canDownloadAll: false,
                    canEdit: _vm.canEdit,
                    canDelete: _vm.canEdit,
                    showAllDeleteBtn: false,
                    showDeleteBtnFunc: _vm.showAttachmentsDelBtn,
                    updateDescriptionCb: _vm.setTenantUpdatedAt,
                    deleteFileCb: _vm.setTenantUpdatedAt,
                    uploadSuccessCb: _vm.setTenantUpdatedAt,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }